import ci from 'ci-info';
import { getTestOverrides } from '@wix/cli-test-overrides';
import z from 'zod';

const remoteLogContextSchema = z.record(z.string(), z.unknown());

function getRemoteLogContext() {
  const remoteContext = process.env.REMOTE_MACHINE_LOG_CONTEXT;
  if (!remoteContext) {
    return {};
  }
  try {
    const parsed = JSON.parse(remoteContext);
    return remoteLogContextSchema.parse(parsed);
  } catch {
    return {};
  }
}

export const createEnv = () => {
  // CI detection should be configurable per test, not bound to the runtime environment.
  // This prevents environment-driven variability (e.g., local vs. GitHub Actions) and ensures predictable behavior.
  const overrides = getTestOverrides();
  return {
    isCI: overrides.isCI ?? ci.isCI,
    isPR: overrides.isPR ?? ci.isPR,
    ciName: overrides.ciName ?? ci.name ?? process.env.CI_NAME ?? null,
    cliEnvName:
      overrides.cliEnvName ?? process.env.WIX_RUNTIME_ENVIRONMENT ?? null,
    cliTrackingId: overrides.cliTrackingId ?? process.env.TRACKING_ID ?? null,
    remoteLogContext: getRemoteLogContext(),
  };
};
